import React from 'react';
import { SvgIcon } from '../../common/SvgIcon';
import { simpleIconPropsTypes } from '../propTypes';

export const IconGovBuilding = ({ width = 20, height = 21, color = 'primary', fullSize = false }) => {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 20 21" color={color} fullSize={fullSize}>
      <path d="M5 9H2V16H5V9Z" fill="currentColor" />
      <path d="M11.5 9H8.5V16H11.5V9Z" fill="currentColor" />
      <path d="M20 18H0V21H20V18Z" fill="currentColor" />
      <path d="M18 9H15V16H18V9Z" fill="currentColor" />
      <path d="M10 0L0 5V7H20V5L10 0Z" fill="currentColor" />
    </SvgIcon>
  );
};

IconGovBuilding.propTypes = simpleIconPropsTypes;
